import { Button } from "@mui/material";
import ReactJsonViewCompare from 'react-json-view-compare';

import { JOURNAL_ITEMS_COUNT } from "~/const";
import { myUseState } from "~/hooks/myUseState";
import { compactObj } from "~/utils/utils";
import { useTrans } from "~/hooks/useTrans";

import "./style.less";

type TObj = Record<string, never>;

interface IState {
	isCompact: boolean;
	hasMoreItems: boolean;
	origData: TObj;
	newData: TObj;
	compactOrigData: TObj;
	compactNewData: TObj;
}

interface IJsonViewer {
	origData: TObj;
	newData: TObj;
}

export default function JsonViewer({
	origData = {},
	newData = {},
}: IJsonViewer) {
	const { trans } = useTrans();
	const { state, setState } = myUseState<IState>(() => {
		const origLen = Object.keys(origData).length;
		const newLen = Object.keys(newData).length;
		const hasMoreItems = origLen > JOURNAL_ITEMS_COUNT || newLen > JOURNAL_ITEMS_COUNT;

		return {
			isCompact: true,
			hasMoreItems,
			compactOrigData: compactObj(origData, JOURNAL_ITEMS_COUNT),
			compactNewData: compactObj(newData, JOURNAL_ITEMS_COUNT),
			origData,
			newData,
		};
	});

	return <div className="jsonViewer">
		<ReactJsonViewCompare oldData={state.isCompact ? state.compactOrigData : state.origData} newData={state.isCompact ? state.compactNewData : state.newData} />
		{ state.hasMoreItems && <div className="jsonViewer__buttonArea">
			<Button onClick={() => setState(prev => ({ ...prev, isCompact: !prev.isCompact }))} variant="outlined">
				{ state.isCompact ? trans("jsonViewer.showMore") : trans("jsonViewer.hide") }
			</Button>
		</div> }
	</div>;
}
